export default {
  RH: {
    SHOW_REPORT_BODY: 'RH.SHOW_REPORT_BODY',
    UPDATE_COMPLETE: 'RH.UPDATE_COMPLETE',
  },
  PHOTO: {
    SELECTOR_RESET: 'PHOTO.SELECTOR_RESET',
  }
}
